import { gql } from 'urql';

export const LIST_PROVEEDORES = gql`
  query ListProveedores($search: String, $pagination: PaginationInput) {
    listProveedores(search: $search, pagination: $pagination) {
      items {
        id
        razonSocial
        cuit
        condicionIVA
        email
        telefono
        direccion
        localidad
        provincia
        activo
        fechaAlta
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const GET_PROVEEDOR = gql`
  query GetProveedor($id: ID!) {
    getProveedor(id: $id) {
      id
      razonSocial
      cuit
      condicionIVA
      email
      telefono
      direccion
      localidad
      provincia
      notas
      activo
      fechaAlta
    }
  }
`;

export const CREATE_PROVEEDOR = gql`
  mutation CreateProveedor($input: ProveedorInput!) {
    createProveedor(input: $input) {
      id
    }
  }
`;

export const UPDATE_PROVEEDOR = gql`
  mutation UpdateProveedor($id: ID!, $input: ProveedorUpdateInput!) {
    updateProveedor(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_PROVEEDOR = gql`
  mutation DeleteProveedor($id: ID!) {
    deleteProveedor(id: $id)
  }
`;
